/**
 * UpgradeRequiredModal – Professionele modal bij 403 Forbidden (tier upgrade vereist)
 * Voorkomt crash of datalek; toont duidelijke Nederlandse melding.
 */

import { Crown } from 'lucide-react'

export default function UpgradeRequiredModal({ isOpen, onClose, message }) {
  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50">
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-xl p-6 max-w-md mx-4">
        <div className="flex items-center justify-center w-16 h-16 mx-auto mb-4 bg-amber-100 dark:bg-amber-900/30 rounded-full">
          <Crown className="w-8 h-8 text-amber-600 dark:text-amber-400" />
        </div>
        <h3 className="text-xl font-semibold text-gray-900 dark:text-white text-center mb-2">
          Upgrade vereist
        </h3>
        <p className="text-gray-600 dark:text-gray-400 text-center mb-6">
          {message || 'Deze functie vereist een upgrade van uw abonnement. Bekijk de beschikbare abonnementen.'}
        </p>
        <div className="flex gap-3">
          <a
            href="/billing"
            className="flex-1 px-4 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-medium text-center transition-colors"
          >
            Bekijk abonnementen
          </a>
          <button
            onClick={onClose}
            className="flex-1 px-4 py-3 bg-gray-200 dark:bg-gray-600 hover:bg-gray-300 dark:hover:bg-gray-500 text-gray-700 dark:text-gray-200 rounded-lg font-medium transition-colors"
          >
            Sluiten
          </button>
        </div>
      </div>
    </div>
  )
}
